var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-left",attrs:{"aria-label":_vm.$id(_vm.date, 'dateTime'),"data-balloon-pos":"left"},domProps:{"innerHTML":_vm._s(_vm.readableTime)}})}
var staticRenderFns = []

export { render, staticRenderFns }